@file:OptIn(InternalResourceApi::class)

package dev.jfronny.zerointerest.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.ThemeQualifier

private const val MD: String =
    "composeResources/dev.jfronny.zerointerest.shared.generated.resources/"

@delegate:ResourceContentHash(1_484_575_626)
internal val Res.drawable.app_icon: DrawableResource by lazy {
      DrawableResource("drawable:app_icon", setOf(
        ResourceItem(setOf(ThemeQualifier.DARK, ), "${MD}drawable-dark/app_icon.xml", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/app_icon.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_021_314_471)
internal val Res.drawable.ic_client_placeholder: DrawableResource by lazy {
      DrawableResource("drawable:ic_client_placeholder", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_client_placeholder.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("app_icon", Res.drawable.app_icon)
  map.put("ic_client_placeholder", Res.drawable.ic_client_placeholder)
}
